import React, { FC } from 'react';
import { Spin } from 'antd';
import { SpinProps } from 'antd/lib/spin';

interface LoadingProps extends SpinProps {}
const Loading: FC<LoadingProps> = (props) => (
  <Spin {...props} className="CommonLoading">
    {props.children}
  </Spin>
);
export default Loading;
